import React, { useState } from 'react';

export type IThemeState = {
  themeHasBeenChanged: boolean;
  setThemeHasBeenChanged: (themeHasBeenChanged: boolean) => void;
}

export const ThemeContext = React.createContext<IThemeState>({
  themeHasBeenChanged: false,
  setThemeHasBeenChanged: () => {}
})

export const ThemeContextProvider = (props: any) => {

  const setThemeHasBeenChanged = (themeHasBeenChanged: boolean) => {
    setState({ ...state, themeHasBeenChanged: themeHasBeenChanged })
  };

  const initState: IThemeState = {
    themeHasBeenChanged: false,
    setThemeHasBeenChanged: setThemeHasBeenChanged
  };

  const [state, setState] = useState(initState);

  return (
    <ThemeContext.Provider value={state}>
      {props.children}
    </ThemeContext.Provider>
  )
}